/* eslint-disable max-len */
export {
  mdiAccessPoint,
  mdiAccount,
  mdiAccountBox,
  mdiAccountCircle,
  mdiAccountCircleOutline,
  mdiAccountFilter,
  mdiAccountGroupOutline,
  mdiAccountMultiple,
  mdiAccountMultipleOutline,
  mdiAccountOutline,
  mdiAccountSupervisorCircle,
  mdiAirballoon,
  mdiAlarm,
  mdiAlarmCheck,
  mdiAlert,
  mdiAlertCircle,
  mdiAlertCircleOutline,
  mdiAlertOctagon,
  mdiAndroid,
  mdiAntenna,
  mdiAppleKeyboardCommand,
  mdiAppleKeyboardControl,
  mdiAppleKeyboardShift,
  mdiAppleKeyboardOption,
  mdiApps,
  mdiArchivePlusOutline,
  mdiArrowCollapseLeft,
  mdiArrowCollapseRight,
  mdiArrowDown,
  mdiArrowLeft,
  mdiArrowLeftBoldBoxOutline,
  mdiArrowRight,
  mdiArrowRightBold,
  mdiArrowRightBoldBoxOutline,
  mdiArrowRightThick,
  mdiArrowUp,
  mdiArrowUpBold,
  mdiArrowUpBoldBox,
  mdiArrowUpBoldBoxOutline,
  mdiArrowUpBoldCircleOutline,
  mdiAxisArrow,
  mdiBackspace,
  mdiBackupRestore,
  mdiBattery,
  mdiBeaker,
  mdiBeakerOutline,
  mdiBeer,
  mdiBell,
  mdiBellOutline,
  mdiBellRing,
  mdiBellRingOutline,
  mdiBike,
  mdiBlinds,
  mdiBook,
  mdiBookMultiple,
  mdiBookmark,
  mdiBookmarkMinus,
  mdiBookmarkOutline,
  mdiBookOpenPageVariant,
  mdiBookVariant,
  mdiBottleTonicPlus,
  mdiBriefcase,
  mdiBriefcaseVariant,
  mdiBriefcaseVariantOutline,
  mdiBrightness5,
  mdiBroadcast,
  mdiBrush,
  mdiBugOutline,
  mdiBullhorn,
  mdiBullhornOutline,
  mdiBullseye,
  mdiBullseyeArrow,
  mdiCached,
  mdiCakeVariant,
  mdiCalendar,
  mdiCalendarBlank,
  mdiCalendarBlankOutline,
  mdiCalendarRange,
  mdiCallSplit,
  mdiCamera,
  mdiCancel,
  mdiCardBulleted,
  mdiCart,
  mdiCartOutline,
  mdiCast,
  mdiCellphone,
  mdiChartLine,
  mdiCheck,
  mdiCheckBold,
  mdiCheckboxBlankOutline,
  mdiCheckboxMarked,
  mdiCheckboxBlankCircleOutline,
  mdiCheckboxMarkedCircle,
  mdiCheckCircle,
  mdiApplicationBracketsOutline,
  mdiCheckCircleOutline,
  mdiCheckOutline,
  mdiChevronDoubleLeft,
  mdiChevronDoubleRight,
  mdiChevronDown,
  mdiChevronLeft,
  mdiChevronRight,
  mdiAccountGroup,
  mdiChevronUp,
  mdiCircle,
  mdiCircleEditOutline,
  mdiCircleHalf,
  mdiCircleOutline,
  mdiNewBox,
  mdiCity,
  mdiClipboardMultipleOutline,
  mdiClipboardText,
  mdiClipboardTextOutline,
  mdiClock,
  mdiClockOutline,
  mdiClockStart,
  mdiClockTimeFourOutline,
  mdiClose,
  mdiCloseCircle,
  mdiCloseCircleOutline,
  mdiClosedCaption,
  mdiClosedCaptionOutline,
  mdiCloud,
  mdiCloudOutline,
  mdiCloudUpload,
  mdiCodeJson,
  mdiCodeTags,
  mdiCodeTagsCheck,
  mdiCog,
  mdiCogOutline,
  mdiCogs,
  mdiComment,
  mdiUnfoldLessHorizontal,
  mdiUnfoldMoreVertical,
  mdiArrowCollapseVertical,
  mdiCompassOutline,
  mdiConsole,
  mdiContentCopy,
  mdiContentSave,
  mdiContentSaveCogOutline,
  mdiControllerClassicOutline,
  mdiCookie,
  mdiCreationOutline,
  mdiCreditCardOutline,
  mdiCrosshairsGps,
  mdiCrown,
  mdiCupcake,
  mdiCursorPointer,
  mdiDatabaseSearchOutline,
  mdiDelete,
  mdiDeleteOutline,
  mdiDesktopTowerMonitor,
  mdiDialpad,
  mdiDomain,
  mdiDotsHorizontal,
  mdiDotsVertical,
  mdiDownload,
  mdiDownloadBoxOutline,
  mdiDropbox,
  mdiEarth,
  mdiEmail,
  mdiEmailOpen,
  mdiEmailOpenOutline,
  mdiEmailOutline,
  mdiEmoticon,
  mdiEmoticonCool,
  mdiEmoticonDead,
  mdiEmoticonExcited,
  mdiEmoticonHappy,
  mdiEmoticonNeutral,
  mdiEmoticonOutline,
  mdiEmoticonSad,
  mdiEmoticonTongue,
  mdiExport,
  mdiExportVariant,
  mdiEye,
  mdiEyeOutline,
  mdiEyedropper,
  mdiEyeOff,
  mdiFacebook,
  mdiFactory,
  mdiFastForward,
  mdiFastForward10,
  mdiFileDocumentOutline,
  mdiFileExcel,
  mdiFileFind,
  mdiFilePlus,
  mdiFileImage,
  mdiFileOutline,
  mdiFilePdfBox,
  mdiFileTree,
  mdiFilter,
  mdiFilterVariant,
  mdiFindReplace,
  mdiFire,
  mdiFireCircle,
  mdiFirework,
  mdiFlag,
  mdiFlaskEmptyOutline,
  mdiFlaskOutline,
  mdiFolder,
  mdiFolderNetwork,
  mdiFolderOpen,
  mdiFolderOutline,
  mdiFolderPlus,
  mdiFolderZipOutline,
  mdiFoodApple,
  mdiFormatAlignCenter,
  mdiFormatAlignJustify,
  mdiFormatAlignLeft,
  mdiFormatAlignRight,
  mdiFormatBold,
  mdiFormatColorFill,
  mdiFormatColorText,
  mdiFormatHeader1,
  mdiFormatItalic,
  mdiFormatListBulleted,
  mdiFormatListBulletedSquare,
  mdiFormatListChecks,
  mdiFormatListNumbered,
  mdiFormatUnderline,
  mdiFormatVerticalAlignBottom,
  mdiFormatWrapInline,
  mdiForum,
  mdiForward,
  mdiFullscreen,
  mdiFullscreenExit,
  mdiFunction,
  mdiGavel,
  mdiGestureTapButton,
  mdiGithub,
  mdiGlassMug,
  mdiGlassMugVariant,
  mdiGlassWine,
  mdiGoogleNearby,
  mdiHandBackRight,
  mdiHandBackRightOutline,
  mdiHandshakeOutline,
  mdiHeadQuestionOutline,
  mdiHeart,
  mdiHeartOutline,
  mdiHeartPulse,
  mdiHelpCircleOutline,
  mdiHistory,
  mdiHome,
  mdiHomeCity,
  mdiHomeOutline,
  mdiHomeVariant,
  mdiHorseVariantFast,
  mdiHumanMaleBoard,
  mdiHumanMaleFemaleChild,
  mdiIceCream,
  mdiImage,
  mdiImageEdit,
  mdiImageEditOutline,
  mdiImageFilterHdr,
  mdiImageOutline,
  mdiInboxArrowDown,
  mdiInformation,
  mdiInformationOutline,
  mdiInstagram,
  mdiKeyboardOutline,
  mdiKeyboardReturn,
  mdiKeyboardSpace,
  mdiLabel,
  mdiLanguageHtml5,
  mdiLanguageMarkdown,
  mdiLanguageMarkdownOutline,
  mdiLanguageTypescript,
  mdiLaptop,
  mdiLayersOutline,
  mdiLayersTriple,
  mdiLeaf,
  mdiLicense,
  mdiLifebuoy,
  mdiLightningBolt,
  mdiLightbulbOnOutline,
  mdiLink,
  mdiLinkedin,
  mdiLiquor,
  mdiListStatus,
  mdiLock,
  mdiLockOutline,
  mdiLogin,
  mdiLoginVariant,
  mdiLogoutVariant,
  mdiMagnify,
  mdiMagnifyMinusOutline,
  mdiMagnifyPlusOutline,
  mdiMapMarker,
  mdiMapMarkerOff,
  mdiMapMarkerOutline,
  mdiMaterialDesign,
  mdiMedal,
  mdiMenu,
  mdiMenuDown,
  mdiMenuLeft,
  mdiMenuRight,
  mdiMenuUp,
  mdiMessage,
  mdiMessageOutline,
  mdiMessageText,
  mdiMessageTextOutline,
  mdiMicrophone,
  mdiMicrophoneOff,
  mdiMinus,
  mdiMinusBox,
  mdiMinusCircle,
  mdiMonitor,
  mdiMonitorScreenshot,
  mdiMonitorSmall,
  mdiMusicNote,
  mdiNature,
  mdiNewspaperVariantOutline,
  mdiNodejs,
  mdiNumeric,
  mdiNumeric0,
  mdiNumeric0Box,
  mdiNumeric1,
  mdiNumeric1Box,
  mdiNumeric2,
  mdiNumeric2Box,
  mdiNumeric3,
  mdiNumeric3Box,
  mdiNumeric4,
  mdiNumeric4Box,
  mdiNumeric5,
  mdiNumeric5Box,
  mdiNumeric6,
  mdiNumeric6Box,
  mdiNumeric7,
  mdiNumeric7Box,
  mdiNumeric8,
  mdiNumeric8Box,
  mdiNumeric9,
  mdiNumeric9Box,
  mdiOpenInNew,
  mdiPackage,
  mdiPackageVariant,
  mdiPackageVariantClosed,
  mdiPageFirst,
  mdiPageLayoutSidebarLeft,
  mdiPageLast,
  mdiPageNext,
  mdiPalette,
  mdiPaletteOutline,
  mdiPaletteSwatchOutline,
  mdiPaperclip,
  mdiPause,
  mdiPencil,
  mdiPencilOutline,
  mdiPhone,
  mdiPhoneInTalk,
  mdiPhoneHangupOutline,
  mdiPictureInPictureBottomRight,
  mdiPin,
  mdiPinOff,
  mdiPinOutline,
  mdiPlay,
  mdiPlayCircleOutline,
  mdiPlus,
  mdiPlusCircle,
  mdiPlusOutline,
  mdiPost,
  mdiPostOutline,
  mdiPound,
  mdiPower,
  mdiPuzzle,
  mdiPuzzleOutline,
  mdiRadioboxBlank,
  mdiRadioboxMarked,
  mdiRecord,
  mdiReddit,
  mdiRefresh,
  mdiRenameOutline,
  mdiRepeat,
  mdiReply,
  mdiRestart,
  mdiRewind,
  mdiRewind10,
  mdiRocketLaunchOutline,
  mdiSass,
  mdiSchool,
  mdiScriptText,
  mdiScriptTextOutline,
  mdiSend,
  mdiServerPlus,
  mdiShapeOutline,
  mdiShareVariant,
  mdiShareVariantOutline,
  mdiShieldLockOutline,
  mdiShieldStarOutline,
  mdiShuffleVariant,
  mdiSignal,
  mdiSignalCellularOutline,
  mdiSilverware,
  mdiSilverwareForkKnife,
  mdiSineWave,
  mdiSkipNext,
  mdiSkipPrevious,
  mdiSnowflake,
  mdiSortAscending,
  mdiSortDescending,
  mdiSourceCommit,
  mdiSpaceInvaders,
  mdiSpeedometer,
  mdiSpeedometerMedium,
  mdiSquare,
  mdiStar,
  mdiStarCircle,
  mdiStarCircleOutline,
  mdiStarHalfFull,
  mdiStarOutline,
  mdiStorefrontOutline,
  mdiStoreOutline,
  mdiSvg,
  mdiSwapVertical,
  mdiTable,
  mdiTablet,
  mdiTag,
  mdiTagOutline,
  mdiTarget,
  mdiTelevisionPlay,
  mdiTextBoxSearchOutline,
  mdiThemeLightDark,
  mdiThumbDown,
  mdiThumbUp,
  mdiTicket,
  mdiTimerSand,
  mdiTire,
  mdiTranslate,
  mdiTrashCan,
  mdiTriangle,
  mdiTwitter,
  mdiUnfoldMoreHorizontal,
  mdiUpdate,
  mdiUpload,
  mdiVariable,
  mdiVectorDifferenceAb,
  mdiVideoInputComponent,
  mdiVideoOff,
  mdiVideoOutline,
  mdiVideoVintage,
  mdiViewDashboard,
  mdiViewDashboardOutline,
  mdiViewGridOutline,
  mdiViewListOutline,
  mdiViewModule,
  mdiVolumeHigh,
  mdiVolumeLow,
  mdiVolumeMedium,
  mdiVolumeVariantOff,
  mdiVuetify,
  mdiWater,
  mdiWeatherHurricane,
  mdiWeatherNight,
  mdiWeatherPouring,
  mdiWeatherSunny,
  mdiWeatherWindy,
  mdiWhiteBalanceSunny,
  mdiWidgetsOutline,
  mdiWifi,
  mdiWifiStrength2,
  mdiWifiStrength3,
  mdiWifiStrength4,
  mdiWifiStrengthAlertOutline,
  mdiWindowMaximize,
  mdiWindowMinimize,
  mdiWindowRestore,
  mdiWrench,
} from '@mdi/js'

export const mdiDiscord = 'M22,24L16.75,19L17.38,21H4.5A2.5,2.5 0 0,1 2,18.5V3.5A2.5,2.5 0 0,1 4.5,1H19.5A2.5,2.5 0 0,1 22,3.5V24M12,6.8C9.32,6.8 7.44,7.95 7.44,7.95C8.47,7.03 10.27,6.5 10.27,6.5L10.1,6.33C8.41,6.36 6.88,7.53 6.88,7.53C5.16,11.12 5.27,14.22 5.27,14.22C6.67,16.03 8.75,15.9 8.75,15.9L9.46,15C8.21,14.73 7.42,13.62 7.42,13.62C7.42,13.62 9.3,14.9 12,14.9C14.7,14.9 16.58,13.62 16.58,13.62C16.58,13.62 15.79,14.73 14.54,15L15.25,15.9C15.25,15.9 17.33,16.03 18.73,14.22C18.73,14.22 18.84,11.12 17.12,7.53C17.12,7.53 15.59,6.36 13.9,6.33L13.73,6.5C13.73,6.5 15.53,7.03 16.56,7.95C16.56,7.95 14.68,6.8 12,6.8M9.93,10.59C10.58,10.59 11.11,11.16 11.1,11.86C11.1,12.55 10.58,13.13 9.93,13.13C9.29,13.13 8.77,12.55 8.77,11.86C8.77,11.16 9.28,10.59 9.93,10.59M14.1,10.59C14.75,10.59 15.27,11.16 15.27,11.86C15.27,12.55 14.75,13.13 14.1,13.13C13.46,13.13 12.94,12.55 12.94,11.86C12.94,11.16 13.45,10.59 14.1,10.59Z'
export const mdiFormatTextdirectionLToR = 'M21,18L17,14V17H5V19H17V22M9,10V15H11V4H13V15H15V4H17V2H9A4,4 0 0,0 5,6A4,4 0 0,0 9,10Z'
export const mdiFormatTextdirectionRToL = 'M8,17V14L4,18L8,22V19H20V17M10,10V15H12V4H14V15H16V4H18V2H10A4,4 0 0,0 6,6A4,4 0 0,0 10,10Z'
// Custom: Bluesky official path provided by user (single path, 24x24 viewBox)
export const mdiBluesky = 'M12 10.8c-1.087-2.114-4.046-6.053-6.798-7.995C2.566.944 1.561 1.266.902 1.565.139 1.908 0 3.08 0 3.768c0 .69.378 5.65.624 6.479.815 2.736 3.713 3.66 6.383 3.364.136-.02.275-.039.415-.056-.138.022-.276.04-.415.056-3.912.58-7.387 2.005-2.83 7.078 5.013 5.19 6.87-1.113 7.823-4.308.953 3.195 2.05 9.271 7.733 4.308 4.267-4.308 1.172-6.498-2.74-7.078a8.741 8.741 0 0 1-.415-.056c.14.017.279.036.415.056 2.67.297 5.568-.628 6.383-3.364.246-.828.624-5.79.624-6.478 0-.69-.139-1.861-.902-2.206-.659-.298-1.664-.62-4.3 1.24C16.046 4.748 13.087 8.687 12 10.8Z'
